import { useEffect, useState } from 'react';
import { ethers, Signer } from 'ethers';
import { useSelector } from 'react-redux';

import {
  getAppChainId,
  getWalletAddress,
  getWalletChainId,
} from '../../redux/selectors';
import { useWalletAPI } from '../useWalletAPI';
import { useAppNetwork } from '../useAppNetwork';

export function useSigner(): ethers.Signer | undefined {
  const appChainId = useSelector(getAppChainId);
  const appNetwork = useAppNetwork();
  const walletChainId = useSelector(getWalletChainId);
  const walletAddress = useSelector(getWalletAddress);

  const [signer, setSigner] = useState<Signer>();

  const walletAPI = useWalletAPI();

  useEffect(() => {
    if (
      walletChainId !== parseInt(appChainId, 10) ||
      // we need to use walletAddress here to manually update signer on account change
      walletAddress === undefined
    ) {
      setSigner(undefined);
      return;
    }

    walletAPI?.getSigner().then(setSigner).catch(console.error);
  }, [walletChainId, appChainId, walletAPI, appNetwork.rpc, walletAddress]);
  return signer;
}
